import script from "./SearchWorkbench.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchWorkbench.vue?vue&type=script&setup=true&lang=js"

import "./SearchWorkbench.vue?vue&type=style&index=0&id=22433f3a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22433f3a"]])

export default __exports__